module.exports = __webpack_public_path__ + "img/mc_mp.69360ecf.png";